module.exports = __webpack_public_path__ + "files/08c94691e08dbc65e7855dc0279d40e6.png";